export default {
  origemCollection: [],
};
